export const Region = {
  AMERICA: "Americas",
  EUROPE: "Europe",
  ASIA: "Asia",
  Australia_NewZealand: "Australia/New Zealand",
  REST: "Rest of the world",
};
